/**
 * /callback landing component (b2c mode). By the time we land here, createMsalInstance() has
 * already run handleRedirectPromise(), so once MSAL settles (inProgress === "none") the account
 * is in the cache and we simply bounce back to home. Mirrors the skySign/PoC callback.
 */
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function Callback() {
  const { inProgress } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    if (inProgress === InteractionStatus.None) {
      navigate("/", { replace: true });
    }
  }, [inProgress, navigate]);

  return <AuthLoader label="Completing sign in" />;
}

/** Minimal inert spinner (no PHI, no dependency on the heavier brand loader). */
export function AuthLoader({ label }: { label: string }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 12,
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontFamily: "system-ui",
        color: "#444",
      }}
    >
      <div
        style={{
          width: 40,
          height: 40,
          border: "3px solid #eee",
          borderTop: "3px solid #FFB31C",
          borderRadius: "50%",
          animation: "skycare-spin 1s linear infinite",
        }}
      />
      <span>{label}</span>
      <style>{"@keyframes skycare-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }"}</style>
    </div>
  );
}
